export const ROLES = {
  ADMIN: "Admin",
  MODERATOR: "Moderator",
  VIEWER: "Viewer",
};

/** Admin panel login access (orders / analytics / tools depending on role). */
export function canAccessPanel(role) {
  return (
    role === ROLES.ADMIN ||
    role === ROLES.MODERATOR ||
    role === ROLES.VIEWER
  );
}

export function canViewOrders(role) {
  return canAccessPanel(role);
}

export function canViewAnalytics(role) {
  return canAccessPanel(role);
}

/** Status changes, WhatsApp, delete, print queue, etc. */
export function canMutateOrders(role) {
  return role === ROLES.ADMIN || role === ROLES.MODERATOR;
}

export function isAdmin(role) {
  return role === ROLES.ADMIN;
}

export function isViewer(role) {
  return role === ROLES.VIEWER;
}

export function getRoleLabel(role, { short = false } = {}) {
  switch (role) {
    case ROLES.ADMIN:
      return short ? "مدير" : "مدير النظام";
    case ROLES.MODERATOR:
      return short ? "مشرف" : "مشرف";
    case ROLES.VIEWER:
      return short ? "متفرج" : "متفرج (عرض فقط)";
    default:
      return role || "";
  }
}
